import { Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { WorkflowStepCompletion } from 'app/models/workflow-step-completion';
import { StepCompletionExecution } from 'app/models/step-completion-execution';
import { Globals } from './globals';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { Resumable, ConfigurationHash } from 'resumablejs';

@Injectable({
  providedIn: 'root'
})
export class StepCompletionExecutionService {

  constructor(private http: HttpClient, private globals: Globals, private formBuilder: FormBuilder, private userService: UserService) { }

  getFormGroup(stepCompletion: WorkflowStepCompletion, stepCompletionExecution?: StepCompletionExecution) {
    let filesControls = {};
    if(stepCompletion.files) {
      stepCompletion.files.forEach( f => {
        filesControls[f.name] = this.formBuilder.group({
              path: [(stepCompletionExecution && stepCompletionExecution.files[f.name])? stepCompletionExecution.files[f.name].path: '', Validators.required],
              storage_id: [(stepCompletionExecution && stepCompletionExecution.files[f.name])? stepCompletionExecution.files[f.name].storage_id: null, Validators.required]
            });
        });
    }

    let formsControls = {};
    if(stepCompletion.forms) {
      stepCompletion.forms.forEach( f => {
        formsControls[f.name] = this.formBuilder.group({
              id: [null],
              template_id: [(stepCompletionExecution && stepCompletionExecution.form_submissions[f.name])? stepCompletionExecution.form_submissions[f.name].template_id: null, Validators.required],
              value: [(stepCompletionExecution && stepCompletionExecution.form_submissions[f.name])? stepCompletionExecution.form_submissions[f.name].value: null, Validators.required]
            });
        });
    }

    return this.formBuilder.group({
        name: [stepCompletion.name, Validators.required],
        comments: [(stepCompletionExecution && stepCompletionExecution.comments)? stepCompletionExecution.comments: ''],
        password: [''],
        files: this.formBuilder.group(filesControls),
        form_submissions: this.formBuilder.group(formsControls)
    });
  }
}